
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Navigation, Pagination]);
window.Swiper = Swiper;

export default function initJerseyAttractionsSwiper() {
  const slider = document.querySelector('[data-jersey-attractions-swiper]');

  if (slider && typeof Swiper !== 'undefined') {
    new Swiper(slider, {
      slidesPerView: 1,
      loop: true,
      navigation: {
        prevEl: slider.querySelector('[data-jersey-attractions-prev]'),
        nextEl: slider.querySelector('[data-jersey-attractions-next]'),
      },
      pagination: {
        el: slider.querySelector('.swiper-pagination'),
        clickable: true
      },
    });
  }
}